export default {
  name: "Pangalan",
  tel: "Telepono",
  save: "I-save",
  confirm: "Kumpirmahin",
  cancel: "Kanselahin",
  delete: "Tanggalin",
  loading: "Naglo-load...",
  noCoupon: "Walang mga kupon",
  nameEmpty: "Mangyaring punuan ang pangalan",
  addContact: "Magdagdag ng contact",
  telInvalid: "Hindi wasto ang format ng numero ng telepono",
  vanCalendar: {
    end: "Wakas",
    start: "Simula",
    title: "Kalendaryo",
    weekdays: ["Lin", "Lun", "Mar", "Miy", "Huw", "Biy", "Sab"],
    monthTitle: (year, month) => `${year}/${month}`,
    rangePrompt: (maxRange) => `Pumili ng hindi hihigit sa ${maxRange} araw`
  },
  vanCascader: {
    select: "Piliin"
  },
  vanPagination: {
    prev: "Nakaraan",
    next: "Susunod"
  },
  vanPullRefresh: {
    pulling: "I-drag pataas para i-refresh...",
    loosing: "I-release para i-refresh..."
  },
  vanSubmitBar: {
    label: "Kabuuan:"
  },
  vanCoupon: {
    unlimited: "Walang limitasyon",
    discount: (discount) => `${discount * 10}% diskwento`,
    condition: (condition) => `Kailangan ng pinakamababang ₱${condition}`
  },
  vanCouponCell: {
    title: "Kupon",
    count: (count) => `Mayroon kang ${count} kupon`
  },
  vanCouponList: {
    exchange: "I-redeem",
    close: "Isara",
    enable: "Available",
    disabled: "Hindi available",
    placeholder: "Kodigo ng kupon"
  },
  vanAddressEdit: {
    area: "Lugar",
    postal: "Postal Code",
    areaEmpty: "Mangyaring piliin ang lugar ng paghahatid",
    addressEmpty: "Hindi maaaring walang laman ang address",
    postalEmpty: "Mali ang postal code",
    addressDetail: "Address",
    defaultAddress: "Itakda bilang default na address"
  },
  vanAddressList: {
    add: "Magdagdag ng bagong address"
  }
}